import { useEffect } from "react";
import Footer from "../Footer";
import Header from "../Header";
import AyutthayaRuins from "../assets/img/Blogs/Thailand/AyutthayaRuins.jpg";
import DoiSuthepTemple from "../assets/img/Blogs/Thailand/DoiSuthepTemple.jpg";
import PhiPhiIslands from "../assets/img/Blogs/Thailand/PhiPhiIslands.jpg";
import RailayBeach from "../assets/img/Blogs/Thailand/RailayBeach.jpg";
import WatArun from "../assets/img/Blogs/Thailand/WatArun.jpg";

const Thailand = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header></Header>
      <div className="mainContent blogDtlWrap">
        <div className="blogBannerWrap thaiBlogBannerWrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 col-lg-8">
                <div className="bannerDataWrap">
                  <h2>Thailand’s Top 5 Must-Visit Places</h2>
                  <p>
                    Thailand, the Land of Smiles, is a dream destination for
                    travelers seeking a mix of history, culture, and natural
                    beauty. Whether you're exploring ancient temples, relaxing
                    on pristine beaches, or diving into the bustling city life,
                    Thailand has something for everyone. Here are the top five
                    must-visit places in Thailand:
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={WatArun} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>01.</span>
                  <h2>Bangkok – The Heart of Thailand</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A bustling metropolis blending rich history with modern
                      vibrancy.
                    </p>
                  </div>
                  <p>
                    Bangkok is Thailand’s energetic capital, filled with grand
                    palaces, traditional markets, and lively nightlife. The
                    Grand Palace, home to the Emerald Buddha, is a must-see,
                    while the Floating Markets offer a unique shopping
                    experience on water. Wat Arun, also known as the Temple of
                    Dawn, provides breathtaking sunset views over the Chao
                    Phraya River.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Grand Palace</p>
                    </li>
                    <li>
                      <p>Floating Markets</p>
                    </li>
                    <li>
                      <p>Wat Arun</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={DoiSuthepTemple} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>02.</span>
                  <h2>Chiang Mai – A Cultural Escape</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A serene city surrounded by lush mountains and ancient
                      temples.
                    </p>
                  </div>
                  <p>
                    Chiang Mai is the cultural hub of northern Thailand, known
                    for its stunning temples and laid-back charm. Doi Suthep
                    Temple, perched on a mountain, offers panoramic views of the
                    city. The Night Bazaar is a paradise for shoppers, while
                    ethical Elephant Sanctuaries provide a chance to interact
                    with rescued elephants responsibly.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p> Doi Suthep</p>
                    </li>
                    <li>
                      <p>Night Bazaar</p>
                    </li>
                    <li>
                      <p>Elephant Sanctuaries</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={PhiPhiIslands} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>03.</span>
                  <h2> Phuket – Sun, Sand, and Serenity</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Thailand’s largest island, famous for its stunning beaches
                      and vibrant nightlife.
                    </p>
                  </div>
                  <p>
                    Phuket is a beach lover’s paradise with soft sand, turquoise
                    waters, and lively entertainment. Patong Beach is the heart
                    of the action, while the Big Buddha offers a peaceful
                    retreat with panoramic island views. For a slice of
                    paradise, take a boat trip to the Phi Phi Islands, where
                    dramatic limestone cliffs meet crystal-clear waters.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Patong Beach</p>
                    </li>
                    <li>
                      <p>Big Buddha</p>
                    </li>
                    <li>
                      <p>Phi Phi Islands</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={RailayBeach} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>04.</span>
                  <h2> Krabi – A Tropical Wonderland</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Home to stunning limestone cliffs, hidden lagoons, and
                      pristine beaches.
                    </p>
                  </div>
                  <p>
                    Krabi’s beauty is truly breathtaking, with Railay Beach
                    offering some of the best rock climbing and sunsets in
                    Thailand. The Emerald Pool is a natural hot spring perfect
                    for relaxation, and the Tiger Cave Temple challenges
                    visitors with a 1,237-step climb to a panoramic viewpoint.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>Railay Beach</p>
                    </li>
                    <li>
                      <p> Emerald Pool</p>
                    </li>
                    <li>
                      <p>Tiger Cave Temple</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction blogTopAttractionPadBtm">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={AyutthayaRuins} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>05.</span>
                  <h2> Ayutthaya – Step Back in Time</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      A UNESCO World Heritage Site filled with historic ruins.
                    </p>
                  </div>
                  <p>
                    Ayutthaya, once the capital of Siam, is now a fascinating
                    historical park. Wander through the Ancient Temples,
                    including the iconic Wat Mahathat, known for the Buddha head
                    entwined in tree roots. A river cruise around the old city
                    offers a unique perspective on its rich history.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p> Ancient Temples</p>
                    </li>
                    <li>
                      <p>Wat Mahathat</p>
                    </li>
                    <li>
                      <p>River Cruise</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="finalThouthWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Final Thoughts</h2>
                <p>
                  Thailand’s diverse landscapes and cultural treasures make it
                  an unforgettable destination. Whether you're looking for
                  adventure, relaxation, or a spiritual journey, these five
                  must-visit locations showcase the very best of Thailand.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="styConnectedWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="styConnectedBox">
                  <div className="imgWrap">
                    <img src={WatArun} className="img-fluid" alt="" />
                  </div>
                  <div className="dataWrap">
                    <h2>
                      Ready to explore Thailand? Book your trip today and
                      experience its magic firsthand!
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default Thailand;
